import r2wc from '@r2wc/react-to-web-component';
import ChatWidget from './chatWidget';

const ChatElement = r2wc(ChatWidget, {
    shadow: "closed",
    props: {
        start_open: "boolean",
        api_key: "string",
        output_type: "string",
        input_type: "string",
        output_component: "string",
        chat_trigger_style: "json",
        host_url: "string",
        flow_id: "string",
        online: "boolean",
        online_message: "string",
        window_title: "string",
        tweaks:"json",
        bot_message_style:"json",
        user_message_style:"json",
        chat_window_style:"json",
        height:"number",
        width:"number",
        session_id:"string",
        chat_output_key:"string",
        error_message_style:"json",
        send_button_style:"json",
        send_icon_style:"json",
        placeholder:"string",
        placeholder_sending:"string",
        input_style:"json",
        input_container_style:"json",
        chat_position: "string",
        brand_color: "string",
        brand_logo_url: "string",
        z_index: "string",
        side_spacing: "string",
        bottom_spacing: "string",
        button_type: "string",
        additional_headers: "json",
        voice_enabled: "boolean",
    },
});

if (!customElements.get("innossistai-chat")) {
    customElements.define("innossistai-chat", ChatElement);
}

// Backward compatibility for existing embeds.
if (!customElements.get("innossistai-chat")) {
    customElements.define("innossistai-chat", ChatElement);
}
